import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './VegetalProduction.css';
import { HiArrowLongLeft } from "react-icons/hi2";
import { useNavigate } from 'react-router-dom';
import cereal_icon from '../../assets/cereais_forragens de sequeiro.svg';
import pasture_irrigation_icon from '../../assets/pastagem_regadio.svg';
import logo_agroinsider_color from '../../assets/logo-agroinsider-color.svg';
import corn_icon from '../../assets/milho.svg';
import rice_icon from '../../assets/arroz.svg';
import other_culture_irrigation_icon from '../../assets/outras_culturas_regadio.svg';
import vineyard_icon from '../../assets/vinha.svg';
import olive_traditional_icon from '../../assets/olival_tradicional.svg';
import almond_culture_icon from '../../assets/amendoal.svg';
import others_orchards_icon from '../../assets/outros_pomares.svg';
import horticultural_icon from '../../assets/horticolas.svg';
import vegetal_production_icon from '../../assets/producao_vegetal_inicio.svg';
import logo_footer_color from '../../assets/logos_footer_color.svg';
import LanguageSwitcher from '../../components/LanguageSwitcher/LanguageSwitcher';

const VegetalProduction = ({ vegetalProduction, setVegetalProduction, farmType }) => {
  const [formData, setFormData] = useState(vegetalProduction);
  const { t } = useTranslation();
  const navigate = useNavigate(); // Para navegação programática

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    const checkboxs = document.getElementById(name);
    if (checkboxs) {
      if (checked) {
        checkboxs.classList.replace('nested-checkboxes-hidden', 'nested-checkboxes-visible');
      } else {
        checkboxs.classList.replace('nested-checkboxes-visible', 'nested-checkboxes-hidden');
      }
    }

    setFormData((prevState) => ({
      ...prevState,
      species: {
        ...prevState.species,
        [name]: checked, // Atualiza o valor específico em 'species'
      },
    }));
  };

  const handleNestedCheckboxChange = (event) => {
    const { name, value } = event.target;
    if (value && value.length > 0) {
      const numericValue = Math.max(0, Number(value)); // Garante que o valor seja >= 0

      if (numericValue) {
        setFormData((prevState) => ({
          ...prevState,
          amount: {
            ...prevState.amount,
            [name]: numericValue,
          },
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        amount: {
          ...prevState.amount,
          [name]: 0,
        },
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setVegetalProduction(formData);
    if (farmType.producaoAnimal) {
      navigate('/animal-production');
    } else {
      navigate('/fuel-spent');
    }
  };

  const handleNavigateBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (

    <form onSubmit={handleSubmit}>
      <div className='form-background'>
        <div className='div-agroinsider-logo'>
          <img src={logo_agroinsider_color} alt="AgroInsider Logo" className="logo" />
        </div>
        <div className='div-page-logo'>
          <img className='img-page-logo' src={vegetal_production_icon} alt="AgroInsider Logo" />
        </div>
        <div className='farm-profile-description'>
          <span className='farm-profile-title'>{t('VegetalProduction.title')}</span>
          <p className='farm-profile-description-text'>{t('VegetalProduction.description')}</p>
        </div>

        <div className="form-profile-form">
          <div className="form-group">
            <div className="nested-checkboxes">
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={cereal_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t("VegetalProduction.inputBoxOption1")}</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="cereal"
                    checked={formData.species.cereal}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div id='cereal' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                <label style={{ gap: "10px" }}>
                  {t('VegetalProduction.cultivated_area')}
                  <input
                    type="text"
                    name="cereal_amount"
                    placeholder={t('VegetalProduction.hectare_placeholder')}
                    checked={formData.amount.cereal}
                    onChange={(e) => handleNestedCheckboxChange(e)}
                    min={0}
                    value={formData.amount.cereal_amount}
                  />
                </label>
              </div>
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={pasture_irrigation_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t("VegetalProduction.inputBoxOption3")}</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="irrigated_pasture"
                    checked={formData.species.irrigated_pasture}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div id='irrigated_pasture' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                <label style={{ gap: "10px" }}>
                  {t('VegetalProduction.cultivated_area')}
                  <input
                    type="text"
                    name="irrigated_pasture_amount"
                    placeholder={t('VegetalProduction.hectare_placeholder')}
                    checked={formData.amount.irrigated_pasture_amount}
                    onChange={(e) => handleNestedCheckboxChange(e)}
                    min={0}
                    value={formData.amount.irrigated_pasture_amount}
                  />
                </label>
              </div>
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={corn_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t("VegetalProduction.inputBoxOption4")}</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="corn"
                    checked={formData.species.corn}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div id='corn' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                <label style={{ gap: "10px" }}>
                  {t('VegetalProduction.cultivated_area')}
                  <input
                    type="text"
                    name="corn_amount"
                    placeholder={t('VegetalProduction.hectare_placeholder')}
                    checked={formData.amount.corn_amount}
                    onChange={(e) => handleNestedCheckboxChange(e)}
                    min={0}
                    value={formData.amount.corn_amount}
                  />
                </label>
              </div>
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={rice_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t("VegetalProduction.inputBoxOption5")}</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="rice"
                    checked={formData.species.rice}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div id='rice' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                <label style={{ gap: "10px" }}>
                  {t('VegetalProduction.cultivated_area')}
                  <input
                    type="text"
                    name="rice_amount"
                    placeholder={t('VegetalProduction.hectare_placeholder')}
                    checked={formData.amount.rice_amount}
                    onChange={(e) => handleNestedCheckboxChange(e)}
                    min={0}
                    value={formData.amount.rice_amount}
                  />
                </label>
              </div>
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={other_culture_irrigation_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t("VegetalProduction.inputBoxOption6")}</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="others_cultures"
                    checked={formData.species.others_cultures}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div id='others_cultures' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                <label style={{ gap: "10px" }}>
                  {t('VegetalProduction.cultivated_area')}
                  <input
                    type="text"
                    name="others_cultures_amount"
                    placeholder={t('VegetalProduction.hectare_placeholder')}
                    checked={formData.amount.others_cultures_amount}
                    onChange={(e) => handleNestedCheckboxChange(e)}
                    min={0}
                    value={formData.amount.others_cultures_amount}
                  />
                </label>
              </div>
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={vineyard_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t("VegetalProduction.inputBoxOption7")}</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="vineyard"
                    checked={formData.species.vineyard}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div id='vineyard' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                <label style={{ gap: "10px" }}>
                  {t('VegetalProduction.cultivated_area')}
                  <input
                    type="text"
                    name="vineyard_amount"
                    placeholder={t('VegetalProduction.hectare_placeholder')}
                    checked={formData.amount.vineyard_amount}
                    onChange={(e) => handleNestedCheckboxChange(e)}
                    min={0}
                    value={formData.amount.vineyard_amount}
                  />
                </label>
              </div>
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={olive_traditional_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t("VegetalProduction.inputBoxOption8")}</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="olive"
                    checked={formData.species.olive}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div id='olive' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                <label style={{ gap: "10px" }}>
                  {t('VegetalProduction.cultivated_area')}
                  <input
                    type="text"
                    name="olive_amount"
                    placeholder={t('VegetalProduction.hectare_placeholder')}
                    checked={formData.amount.olive_amount}
                    onChange={(e) => handleNestedCheckboxChange(e)}
                    min={0}
                    value={formData.amount.olive_amount}
                  />
                </label>
              </div>
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={almond_culture_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t("VegetalProduction.inputBoxOption9")}</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="almond"
                    checked={formData.species.almond}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div id='almond' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                <label style={{ gap: "10px" }}>
                  {t('VegetalProduction.cultivated_area')}
                  <input
                    type="text"
                    name="almond_amount"
                    placeholder={t('VegetalProduction.hectare_placeholder')}
                    checked={formData.amount.almond_amount}
                    onChange={(e) => handleNestedCheckboxChange(e)}
                    min={0}
                    value={formData.amount.almond_amount}
                  />
                </label>
              </div>
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={others_orchards_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <span>{t("VegetalProduction.inputBoxOption10")}</span>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="others_orchards"
                    checked={formData.species.others_orchards}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div id='others_orchards' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                <label style={{ gap: "10px" }}>
                  {t('VegetalProduction.cultivated_area')}
                  <input
                    type="text"
                    name="others_orchards_amount"
                    placeholder={t('VegetalProduction.hectare_placeholder')}
                    checked={formData.amount.others_orchards_amount}
                    onChange={(e) => handleNestedCheckboxChange(e)}
                    min={0}
                    value={formData.amount.others_orchards_amount}
                  />
                </label>
              </div>
              <div className='grid-container-checkbox'>
                <div className='grid-item'>
                  <img alt='icon' src={horticultural_icon} className="icon" />
                </div>
                <div className='grid-item'>
                  <div>
                    <span>{t("VegetalProduction.inputBoxOption11")}</span>
                  </div>
                </div>
                <div className='grid-item'>
                  <input
                    type="checkbox"
                    name="vegetables"
                    checked={formData.species.vegetables}
                    onChange={handleCheckboxChange}
                  />
                </div>
              </div>
              <div id='vegetables' className="nested-checkboxes nested-checkboxes-hidden" style={{ marginLeft: "75px" }}>
                <label style={{ gap: "10px" }}>
                  {t('VegetalProduction.cultivated_area')}
                  <input
                    type="text"
                    name="vegetables_amount"
                    placeholder={t('VegetalProduction.hectare_placeholder')}
                    checked={formData.amount.vegetables_amount}
                    onChange={(e) => handleNestedCheckboxChange(e)}
                    min={0}
                    value={formData.amount.vegetables_amount}
                  />
                </label>
              </div>
            </div>
          </div>


        </div>
        <div className='form-group-bottom-buttons'>
          <div className="form-group-buttons">
            <button className='form-back-button' onClick={() => handleNavigateBack()}>
              <HiArrowLongLeft size={28} />
            </button>
            <button className="form-next-button" type="submit">{t('AnimalProduction.submit')}</button>
          </div>
        </div>
        <LanguageSwitcher />
        <div className='div-logo-footer-color'>
          <img src={logo_footer_color} alt="AgroInsider Logo" className="logo" />
        </div>
      </div>
    </form>
  );
}

export default VegetalProduction;
